var angular = require('angular');
var ngModule = angular.module('/participants/views/participants.html', []);
ngModule.run(['$templateCache', function($templateCache) {
  $templateCache.put('/participants/views/participants.html',
    '<section class="panel panel-participants">\n' +
    '    <header class="panel-heading clearfix">\n' +
    '        <button ng-click="clear()" class="btn btn-danger pull-right">{{ \'CLEAR_ALL\' | translate }}</button>\n' +
    '        <button ng-click="create()" class="btn btn-success pull-right">{{ \'ADD\' | translate }}</button>\n' +
    '\n' +
    '        <sort-button order="order" value="name">{{ \'PAGES.PARTICIPANTS.SORT_NAME\' | translate }}</sort-button>\n' +
    '        <sort-button order="order" value="spokes">{{ \'PAGES.PARTICIPANTS.SORT_SPOKES\' | translate }}</sort-button>\n' +
    '    </header>\n' +
    '</section>\n' +
    '<div class="list-group participants">\n' +
    '    <form class="list-group-item participant participant-form" novalidate role="form" ng-submit="save()" ng-show="pEdit">\n' +
    '        <input type="text" class="form-control" name="name" id="input-name" ng-model="pEdit.name" placeholder="{{ \'PAGES.PARTICIPANTS.PLACEHOLDER_NAME\' | translate }}" required ng-minlength="2"/>\n' +
    '        <span class="participant__spoke"><input type="number" min="1" class="form-control" name="spokes" id="input-spokes" ng-model="pEdit.spokes" placeholder="{{ \'PARTICIPANTS.PLACEHOLDER_SPOKES\' | translate }}" required ng-minlength="1"/></span>\n' +
    '        <button class="btn btn-success" type="submit">{{ \'SAVE\' | translate }}</button>\n' +
    '        <button class="btn btn-danger" ng-click="pEdit = null">{{ \'CANCEL\' | translate }}</button>\n' +
    '    </form>\n' +
    '    <div class="list-group-item participant" ng-repeat="p in participants | orderBy: order.order:order.reverse track by $id(p)">\n' +
    '        <button class="btn btn-danger btn-xs" ng-click="remove(p)">{{ \'REMOVE\' | translate }}</button>\n' +
    '        <button class="btn btn-default btn-xs" ng-click="edit(p)">{{ \'EDIT\' | translate }}</button>\n' +
    '        <strong class="participant__spoke">{{ :: p.spokes }}</strong>\n' +
    '        <span class="participant__name">{{ :: p.name }}</span>\n' +
    '    </div>\n' +
    '    <div class="list-group-item list-group-item-info" ng-if="!participants.length">{{ \'PAGES.PARTICIPANTS.EMPTY\' | translate }}</div>\n' +
    '</div>\n' +
    '');
}]);

module.exports = "/participants/views/participants.html";